export default {
    index: {
        title: "首頁",
        keywords: "劍網3,魔盒,JX3BOX,工具,攻略,資訊,社群",
        description: "劍網3魔盒（JX3BOX）首頁：公告資訊、社群內容、江湖快報等。",
    },
    notice: {
        title: "公告中心",
        keywords: "公告,資訊,更新,活動,兌換通知,JX3BOX",
        description: "公告中心：查看劍網3魔盒的公告動態、營運活動、功能更新與兌換通知。",
        single: {
            title: "公告詳情",
            keywords: "公告詳情,公告,資訊,JX3BOX",
            description: "公告詳情頁：閱讀公告內容、查看更新資訊與互動數據。",
        },
    },
};
